<template>
  <v-btn-toggle v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-btn-toggle>
</template>

<script>
/**
 * @fileoverview Common component for button groups
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */
export default {
  name: "ButtonGroup",
};
</script>

<style lang="scss" scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  padding: $qvo-spacing-4;
  background: $qvo-color-blue-100;
  border-radius: 8px;
  height: 44px;
  &::v-deep {
    .button.v-btn {
      background-color: transparent;
      border-color: transparent !important;
      border-width: 0;
      border-radius: 8px;
      transition-property: background-color;
      height: unset;
      padding: 6px $qvo-spacing-16;
      .label,
      .v-icon {
        color: $qvo-color-blue-400;
      }
      &:hover {
        background-color: $qvo-color-blue-200;
        border: solid transparent;
        border-width: 0;
      }
      &.v-item--active {
        background-color: $qvo-color-blue-400;
        .label,
        .v-icon {
          color: $qvo-color-grey-000;
          &::after {
            background: none;
          }
        }
        &:hover {
          background-color: $qvo-color-blue-700;
        }
      }
    }
  }
}
</style>